// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__JQdmu","header":"Messages_header__3e5bJ"};